import clsx from "clsx";
import React from "react";
import { twMerge } from "tailwind-merge";

export const BGWrapper = ({
    children,
    className,
    ignoretwMerge = false,
}: {
    className?: string;
    children: React.ReactNode;
    ignoretwMerge?: boolean;
}) => {
    return (
        <div
            className={clsx(
                !ignoretwMerge
                    ? twMerge(
                          [
                              "flex items-center w-screen max-w-screen relative py-10 bg-red-50/30",
                              className,
                          ].join(" "),
                      )
                    : clsx(
                          "flex items-center w-screen max-w-screen relative py-10",
                          className,
                      ),
            )}
        >
            {children}
        </div>
    );
};
